import { createAsyncThunk } from '@reduxjs/toolkit';

import { TaxStatementService } from 'api';

import { DownloadTaxStatementProps } from 'models/api';

import { downloadDocuments } from 'utils';

export const downloadTaxStatement = createAsyncThunk(
	'statement/downloadTaxStatement',
	(data: DownloadTaxStatementProps) =>
		downloadDocuments(data, data.fileName, TaxStatementService.download),
);
